import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ZkEButtonColor, ZkEButtonSize } from '@zenklub/ng-ui';
import { IWizardNavigation } from 'app/interfaces/wizard-navigation.interface';
import { GlobalService } from 'app/services/global.service';

@Component({
	selector: 'app-wizard-navigation',
	templateUrl: './wizard-navigation.component.html',
	styleUrls: ['./wizard-navigation.component.scss'],
})
export class WizardNavigationComponent implements OnInit {
	@Output() currentStepItem = new EventEmitter();

	@Input()
	disabledNextButton = false;
	btnActive: boolean;
	firstStep: boolean;
	isMobile: any;
	newRoute: any;
	component: (
		| { id: number; route: string; nextRoute: string; previousRoute: any }
		| { id: number; route: string; nextRoute: any; previousRoute: string }
	)[];
	@Input('activateBtn')
	set activateBtn(activateBtn: any) {
		this.btnActive = activateBtn;
	}
	@Output() termsAlreadyAccepted = new EventEmitter();
	buttonColorType = ZkEButtonColor;
	buttonSizeType = ZkEButtonSize;

	public currentStep: IWizardNavigation | undefined;

	get currentStepId(): number {
		return this.currentStep ? this.currentStep.id : 1;
	}
	steps: IWizardNavigation[] = [];

	constructor(private global: GlobalService) {
		this.steps = [
			{
				id: 1,
				route: 'welcome',
				nextRoute: 'about-zenoffice',
				previousRoute: null,
			},
			{
				id: 2,
				route: 'about-zenoffice',
				nextRoute: 'subscription-data',
				previousRoute: 'welcome',
			},
			{
				id: 3,
				route: 'subscription-data',
				nextRoute: 'choose-plan',
				previousRoute: 'about-zenoffice',
			},
			{
				id: 4,
				route: 'choose-plan',
				nextRoute: null,
				previousRoute: 'subscription-data',
			},
		];
	}

	ngOnInit(): void {
		this.onResize();
		this.currentStep = this.steps.find(
			(step: IWizardNavigation) => step.route === 'welcome'
		);
		this.currentStepItem.emit(this.currentStep?.route);
	}

	onResize() {
		this.isMobile = this.global.isMobileDevice();
	}

	public onBackClick(disabled?): void {
		if (disabled) return;
		if (!this.currentStep || !this.currentStep.previousRoute) {
			return;
		}
		this.termsAlreadyAccepted.emit(true);
		this.newRoute = this.currentStep?.previousRoute;
		this.changeStep(this.newRoute);
	}

	public onNextClick(disabled?): void {
		if (disabled) return;

		if (this.disabledNextButton) {
			return;
		}

		if (this.isLastStep) {
			return;
		}

		if (!this.currentStep || !this.currentStep.nextRoute) {
			return;
		}
		this.newRoute = this.currentStep?.nextRoute;
		this.changeStep(this.newRoute);
	}

	changeStep(newStep) {
		this.currentStep = this.steps.find(
			(step: IWizardNavigation) => step.route === newStep
		);
		this.currentStepItem.emit(this.currentStep?.route);
	}

	get percentage(): number {
		const amountSteps = this.steps.length;
		return (this.currentStepId * 100) / amountSteps;
	}

	get previousPercentage(): number {
		const amountSteps = this.steps.length;
		return ((this.currentStepId - 1) * 100) / amountSteps;
	}

	get isLastStep(): boolean {
		const lastStep = this.steps[this.steps.length - 1];
		if (lastStep) {
			return this.currentStepId === lastStep.id;
		}
		return false;
	}

	isFirstStep() {
		this.firstStep = this.currentStep.previousRoute ? false : true;
		return this.firstStep;
	}
}
